module.exports = __webpack_public_path__ + "img/card2.93007bcb.png";